import * as React from 'react';
import clsx from 'clsx';
import { Button } from '@/components/ui/Button';
import { AUTH_FORM_WIDTH } from '@/components/layout/auth/authFormConstants';

/** @typedef AuthSubmitButtonProps — Props for the auth form submit button. */
interface AuthSubmitButtonProps {
  formId: string;
  isLoading: boolean;
  label: string;
}

/** Primary submit button for auth forms with loading state. */
export const AuthSubmitButton: React.FC<AuthSubmitButtonProps> = ({ formId, isLoading, label }) => (
  <Button
    type='submit'
    form={formId}
    variant='purple-dark'
    className={clsx(
      'rounded-30 text-[length:var(--vs-16,16px)] font-bold uppercase tracking-wide',
      'mx-auto',
      'h-[var(--vs-54,54px)]',
      AUTH_FORM_WIDTH
    )}
    disabled={!!isLoading}
    isLoading={isLoading}
  >
    {label}
  </Button>
);
